<form [formGroup]="form">
  <div class="flex gap-4">
    <div class="control">
      <label>Fritekst</label>
      <input
        pInputText
        formControlName="fritekst"
        style="display: inline-block; width: 200px" />
    </div>
    <div class="control">
      <label>Fra</label>
      <app-let-date-picker
        formControlName="fraDato"
        style="display: inline-block; width: 160px"
        [showTime]="true" />
    </div>
    <div class="control">
      <label>Til</label>
      <app-let-date-picker
        formControlName="tilDato"
        style="display: inline-block; width: 160px"
        [showTime]="true" />
    </div>
    <div class="control">
      <label>&nbsp;</label>
      <p-button
        label="Søg"
        (click)="onClickSearch()"
        icon="pi pi-search"
        type="submit" />
    </div>
    <div class="control">
      <label>&nbsp;</label>
      <p-button
        label="Nulstil"
        (click)="onClickReset()"
        icon="pi pi-times"
        severity="secondary"
        outlined />
    </div>
  </div>
  <div class="flex gap-2"></div>
</form>
